/* eslint-disable @typescript-eslint/no-explicit-any */
import { ALL_SELECT_LABEL } from '../../../utils/constants/global-constants'
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'

interface Attachment {
  blobs: []
  itemKey: string
}
interface Announcement {
  AssignedComponent: string
  'AssignedComponent/MetadataValue': string
  AssignedComponentCode: number
  Attachments: Attachment[]
  Category: string
  'Category/MetadataValue': string
  CategoryCode: number
  Description: string
  ExpirationDate?: string
  Id: string
  IsArchived: boolean
  ItemCreated: string
  ItemCreatedBy: string
  ItemModified: string
  ItemModifiedBy: string
  MAJCOM: string
  'MAJCOM/MetadataValue': string
  MAJCOMCode: number
  Section: string
  'Section/MetadataValue': string
  SectionCode: number
  Tags: string
  Title: string
  eKey: string
  eTag: string
}
interface AnnouncementsFetchArgs {
  isArchived: false | null | true
  isAscending?: boolean
  isNotExpired?: false | true
  orderBy?: string
}
const COLUMN_NAMES = {
  AssignedComponentCode: 'AssignedComponentCode',
  Category: 'Category',
  CategoryCodes: 'CategoryCodes',
  Description: 'Description',
  EKey: 'eKey',
  ETag: 'eTag',
  ExpirationDate: 'ExpirationDate',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemCreatedByEDIPI: 'ItemCreatedBy/edipi',
  ItemCreatedByEmail: 'ItemCreatedBy/email',
  ItemCreatedByFirstName: 'ItemCreatedBy/firstname',
  ItemCreatedByLastName: 'ItemCreatedBy/lastname',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  ItemModifiedByEDIPI: 'ItemModifiedBy/edipi',
  ItemModifiedByEmail: 'ItemModifiedBy/email',
  ItemModifiedByFirstName: 'ItemModifiedBy/firstname',
  ItemModifiedByLastName: 'ItemModifiedBy/lastname',
  Section: 'Section',
  SectionCodes: 'SectionCodes',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  Squadron: 'Squadron',
  Tags: 'Tags',
  Title: 'Title',
}
const LIST_NAME = 'AnnouncementsList'

const constructAnnouncementFilter = (args: AnnouncementsFetchArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchived ?? null))
  if (args.isNotExpired) {
    filters.push(`ExpirationDate ge ${new Date(new Date().setDate(new Date().getDate() -1)).toISOString()}`)
  }
  const filter = and(...filters)
  return filter
}
const getAnnouncements = async (args: AnnouncementsFetchArgs): Promise<Announcement[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructAnnouncementFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.Section,
      COLUMN_NAMES.Category,
      COLUMN_NAMES.AssignedComponentCode,
      COLUMN_NAMES.CategoryCodes,
      COLUMN_NAMES.Description,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.ExpirationDate,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.ServicingMAJCOMCode,
      COLUMN_NAMES.SectionCodes,
      COLUMN_NAMES.Tags,
      COLUMN_NAMES.Title,
      COLUMN_NAMES.ItemCreatedByEmail,
      COLUMN_NAMES.ItemCreatedByEDIPI,
      COLUMN_NAMES.ItemCreatedByFirstName,
      COLUMN_NAMES.ItemCreatedByLastName,
      COLUMN_NAMES.ItemModifiedByEDIPI,
      COLUMN_NAMES.ItemModifiedByEmail,
      COLUMN_NAMES.ItemModifiedByFirstName,
      COLUMN_NAMES.ItemModifiedByLastName,
      COLUMN_NAMES.Squadron,
      'ServicingMAJCOM/MetadataValue',
      'AssignedComponent/MetadataValue'
    )
    .expand(
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModifiedBy,
      'AssignedComponent',
      'ServicingMAJCOM'
    )
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemModified }])
    .get()

  items.forEach((element: Announcement) => {
    element.AssignedComponent = element['AssignedComponent/MetadataValue']
      ? element['AssignedComponent/MetadataValue']
      : ALL_SELECT_LABEL
    element.ServicingMAJCOM = element['ServicingMAJCOM/MetadataValue']
      ? element['ServicingMAJCOM/MetadataValue']
      : ALL_SELECT_LABEL
    element.Category = JSON.parse(element.Category)
    element.Section = JSON.parse(element.Section)
    element.CategoryCodes = JSON.parse(element.CategoryCodes)
    element.SectionCodes = JSON.parse(element.SectionCodes)
  })
  return [...items] as Announcement[]
}

export {
  type Announcement,
  type AnnouncementsFetchArgs,
  type Attachment,
  COLUMN_NAMES,
  LIST_NAME,
  getAnnouncements,
}
